import styles from "./../StudentPage.module.css";

export default function StepSelect({ goal, setGoal, onNext, onBack }) {
    return (
        <div className={styles.formStep}>
            <h3 className={styles.formTitle}>Determine your goal.</h3>

            <div className={styles.radioGroup}>
                {/* OPTION 1 */}
                <label className={styles.radioItem}>
                    <input
                        type="radio"
                        name="goal"
                        value="edit"
                        checked={goal === "edit"}
                        onChange={(e) => setGoal(e.target.value)}
                    />
                    <div className={styles.radioContent}>
                        <span>
                            You have prepared your own article and want help
                            with editing and publishing your scientific paper.
                        </span>
                        <span className={styles.tooltip}>
                            ?
                            <span className={styles.tooltipText}>
                                Our team will edit and publish your own article.
                            </span>
                        </span>
                    </div>
                </label>

                {/* OPTION 2 */}
                <label className={styles.radioItem}>
                    <input
                        type="radio"
                        name="goal"
                        value="sole"
                        checked={goal === "sole"}
                        onChange={(e) => setGoal(e.target.value)}
                    />
                    <div className={styles.radioContent}>
                        <span>
                            You want to commission a finished article under your
                            sole authorship.
                        </span>
                        <span className={styles.tooltip}>
                            ?
                            <span className={styles.tooltipText}>
                                Our team will prepare the article independently
                                from start to publication.
                            </span>
                        </span>
                    </div>
                </label>

                {/* OPTION 3 */}
                <label className={styles.radioItem}>
                    <input
                        type="radio"
                        name="goal"
                        value="group"
                        checked={goal === "group"}
                        onChange={(e) => setGoal(e.target.value)}
                    />
                    <div className={styles.radioContent}>
                        <span>
                            You want to commission a finished article under the
                            authorship of several students.
                        </span>
                        <span className={styles.tooltip}>
                            ?
                            <span className={styles.tooltipText}>
                                Our team will prepare the article independently
                                from start to publication.
                            </span>
                        </span>
                    </div>
                </label>
            </div>

            <div className={styles.formButtons}>
                <button onClick={onBack}>Back</button>
                <button disabled={!goal} onClick={onNext}>
                    Next
                </button>
            </div>
        </div>
    );
}